import { useQuery } from '@tanstack/react-query'
import api, { withAuthenticatedRequest } from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useFetchSignatureByIdUser(id_user: string | undefined) {
  const token = useAccessToken()
  return useQuery({
    queryKey: ['signature', id_user],
    queryFn: async () => {
      if (!id_user) throw new Error('Signature ID_user is required')

      const response = await api.get(`/signatures/${id_user}/user`, withAuthenticatedRequest(token))

      if (response.data) {
        return response.data
      } else {
        throw new Error('Signature not found')
      }
    },
    enabled: Boolean(id_user)
  })
}
